const CONSTANTS = {
  minMonth: 1,
  maxMonth: 7,
  maxBookingTime: 21,
  activities: [
    { name: "rafting", max: 24 },
    { name: "canoraft", max: 24 },
    { name: "hydrospeed", max: 8 },
  ],
  maxPeople: {
    rafting: 24,
    canoraft: 24,
    hydrospeed: 8,
  },
  numGuides: 3,
  maxPeoplePerGuide: 8,
  price: 45,
  deposit: 0.3,
  name: "Jean Rousseau",
  email: "jean@lapagaiedaure.com",
  phone: "07 69 01 84 37",
  siret: "82884929900015",
  hostname: "www.lapagaiedaure.com",
}

export default CONSTANTS
